import React from 'react';

function BackButton({ 
  onClick, 
  text = 'Back to Search',
  variant = 'header' // 'header' or 'auth'
}) {
  const [isHovered, setIsHovered] = React.useState(false);

  const baseStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    textDecoration: isHovered ? 'underline' : 'none',
    padding: '0'
  };

  const headerStyle = {
    ...baseStyle,
    color: '#1d2934',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  };

  const authStyle = {
    ...baseStyle,
    color: '#5e778a',
    marginTop: '16px',
    display: 'block',
    margin: '16px auto 0'
  };

  const style = variant === 'auth' ? authStyle : headerStyle;

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={style}
    >
      ← {text}
    </button>
  );
}

export default BackButton;